import { render, staticRenderFns } from "./CrearTareaColaModalComponent.vue?vue&type=template&id=dd89e350&"
import script from "./CrearTareaColaModalComponent.vue?vue&type=script&lang=js&"
export * from "./CrearTareaColaModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./CrearTareaColaModalComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports